// src/pages/public/About.jsx
import React from "react";
import Seo from "../../components/public/Seo";

export default function About() {
  return (
    <>
      <Seo
        title="About — Veya"
        description="A quiet framework for dressing with intention — built for shoppers who value style, fit, and boutiques."
      />

      <h1 className="public-h1">About</h1>

      <p className="public-lede">
        Veya is not a marketplace. It’s a framework for dressing with intention — and a way for
        boutiques to stay discoverable without becoming loud.
      </p>

      <p className="public-body">
        Shopping should feel considered. Not like a feed you’re meant to keep up with, or a game of
        trend-chasing that makes good pieces feel outdated before they’ve even been worn.
      </p>

      <p className="public-body">
        Veya was built for people who care about how they show up in the world — and for the local
        boutiques doing the work of curating quality, not volume. We’re creating a quiet space where
        you can explore style visually, build outfits with purpose, and choose pieces that actually
        suit your body.
      </p>

      <p className="public-body">
        At the centre of Veya is the idea that your wardrobe is a system — not a pile of purchases.
        Instead of organising clothing by “what’s trending”, we organise it by what it does for you:
        the moods you return to, the silhouettes that flatter you, the fabrics that feel like you,
        and the combinations that make you feel grounded, powerful, soft, or sharp.
      </p>

      <p className="public-body">
        Veya’s fitting room is part of that system. It’s not about perfection — it’s about reducing
        uncertainty. Try-on is there to help you sanity-check proportion and shape so you can make
        fewer, better choices with more confidence.
      </p>

      <p className="public-body">
        For boutiques, Veya is a visibility layer — with intelligence built in. We track the signals
        shoppers create when they browse, save, and try things on, then translate that into
        practical insight: what people are actually drawn to, where there’s demand you don’t have
        inventory, and what your customers are trying to build outfits around. The goal is simple:
        help boutiques compete on curation and service, not discounting.
      </p>

      <p className="public-body">
        Veya is being built slowly and deliberately. Luxury isn’t loud — it’s considered. And the
        future of shopping shouldn’t be endless options. It should be better ones.
      </p>
    </>
  );
}